import { FC, useContext, useEffect, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom";

import StepperModal from "../stepperModal";

import { CaseDetailPropsType, QueryParamsState } from "./types";
import { handleNavigation, isMobileOrTablet, objectToQueryString } from "src/helpers";
import { CASE_DETAIL_HEADER } from "src/constants/manufacturer";
import CancelTreatment from "src/components/modals/cancelTreatment";
import RequestDateOfTreatment from "src/components/modals/requestDateOfTreatment";
import ConfirmIndication from "src/components/modals/confirmIndication";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";
import { AuthContext } from "src/context/authContext";
import PracticeContactInfo from "src/components/practiceContactInfo";
import TableHeader from "src/components/tableHeader";
import { sortTableColumns } from "src/helpers/stats";
import { CaseListingType } from "src/pages/territories/types";
// import { AuthContext } from "src/context/authContext";



const CaseDetail: FC<CaseDetailPropsType> = ({ type, baseUrl, searchParams, CaseDetailListType }): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  // const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  // const toggleIconRef = useRef<HTMLElement | null>(null);
  // const { userData } = useContext(AuthContext)
  const [caseListing, updateCaseListing] = useState<CaseListingType[]>([])
  const [queryParams, updateQueryParams] = useState<QueryParamsState>({
    direction: "desc",
    sort_by: "case_id",
  });

  const [showingModal, setModal] = useState(false);
  const [caseDetails, setCaseDetails] = useState<any>(null);
  const [showCancelIndicationModal, setDataForCancelIndication] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
  const [showRequestTreatmentModal, setDataForRequestModalTreatment] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number, bentype: string }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    bentype: ""
  });
  const [cancelTreatmentModal, setDataForCancelModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });

  const navigate = useNavigate();
  const location = useLocation();
  const { defaultView } = useContext(AuthContext);

  const redirectDecision = () => {
    const isRedirectRequired = handleNavigation(defaultView, location.pathname);
    if (isRedirectRequired) {
      navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true })
    } else {
      navigate(0)
    }
  }

  const openModal = (caseItem: any) => {
    setModal(true);
    setCaseDetails(caseItem);
  };

  useEffect(() => {
    if (CaseDetailListType.length > 0) {
      const caseListings = CaseDetailListType.map((item) => ({...item, doc_name:item?.provider?.doc_name}))
      updateCaseListing(caseListings)
      updateQueryParams({direction:"desc",sort_by:""})
    }
  }, [CaseDetailListType]);





  const { loading: transferRxLoading, data: transferRxData, mutate: transferRxByCaseId } =
    useFetch(APIEndpoints.TRANSFER_RX);

  useEffect(() => {
    if (transferRxData) {
      const { message } = transferRxData as unknown as { code: number; message: string; };
      showToast([message], ToastTypes.SUCCESS);
      redirectDecision()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxData]);

  useEffect(() => {
    if (transferRxLoading) setLoader();
    else hideLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxLoading]);





  const ConfirmAlert = (title: string, buttonName: string, caseId: number) => {
    const result = window.confirm(title);
    if (result) {
      transferRxByCaseId({}, { case_id: caseId, rep_xfer: true })
    }
  };

  const changeIdOrder = (tableHeader: string) => {
    // const updatedQueryParams: QueryParamsState = {
    //   sort_by: tableHeader,
    //   direction: tableHeader === queryParams.sort_by ? (queryParams.direction === "desc" ? "asc" : "desc") : "desc"
    // };

    // switch (updatedQueryParams.sort_by) {
    //   case "case_id":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return Number(item1.case_id) - Number(item2.case_id);
    //       else
    //         return Number(item2.case_id) - Number(item1.case_id);
    //     });
    //     break;

    //   case "patient_id":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return Number(item1.patient_id) - Number(item2.patient_id);
    //       else
    //         return Number(item2.patient_id) - Number(item1.patient_id);
    //     });
    //     break;

    //   case "bi_ct":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return Number(item1.bi_ct) - Number(item2.bi_ct);
    //       else
    //         return Number(item2.bi_ct) - Number(item1.bi_ct);
    //     });
    //     break;

    //   case "qty":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return Number(item1.qty || 0) - Number(item2.qty || 0);
    //       else
    //         return Number(item2.qty || 0) - Number(item1.qty || 0);
    //     });
    //     break;
    //   case "received":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return new Date(item1.received).getTime() - new Date(item2.received).getTime();
    //       else
    //         return new Date(item2.received).getTime() - new Date(item1.received).getTime();
    //     });
    //     break;

    //   case "completed":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return new Date(item1.completed).getTime() - new Date(item2.completed).getTime();
    //       else
    //         return new Date(item2.completed).getTime() - new Date(item1.completed).getTime();
    //     });
    //     break;
    //   case "payer":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return (item1.payer || "").localeCompare(item2.payer || "");
    //       else
    //         return (item2.payer || "").localeCompare(item1.payer || "");
    //     });
    //     break;
    //   case "case_status":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return (item1.case_status || "").localeCompare(item2.case_status || "");
    //       else
    //         return (item2.case_status || "").localeCompare(item1.case_status || "");
    //     });
    //     break;
    //   case "provider.doc_name":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return item1.provider.doc_name.localeCompare(item2.provider.doc_name);
    //       else
    //         return item2.provider.doc_name.localeCompare(item1.provider.doc_name);
    //     });
    //     break;
    // }

    // updateQueryParams(updatedQueryParams);
    sortTableColumns(tableHeader, queryParams, updateQueryParams, caseListing, updateCaseListing)
  };

  useEffect(() => {
    localStorage.setItem("CaseId", (CaseDetailListType && CaseDetailListType.length > 0 && CaseDetailListType[0].case_id ? (CaseDetailListType[0].case_id).toString() : ""))
    localStorage.setItem("PrescriptionId", (CaseDetailListType && CaseDetailListType.length > 0 && CaseDetailListType[0].prescription_id ? (CaseDetailListType[0].prescription_id).toString() : ""))
    // if (CaseDetailListType && CaseDetailListType.length > 0) {
    //   changeIdOrder('case_id');
    // }
    if (CaseDetailListType && CaseDetailListType.length > 0) {
    CaseDetailListType.sort((a, b) => Number(b.case_id) - Number(a.case_id));
    updateQueryParams({ sort_by: "case_id", direction: "desc" });
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <>
      <div className="card">
        <div className="card-header bg-success-subtle">
          <h4 className="text-center text-black m-0">Case Details</h4>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive" style={{ minHeight: "50px", maxHeight: "350px" }}>

            <table className="table table-sm mb-0 case-detail-thead">
              <thead className="sticky-top" style={{ backgroundColor: '#FFF!important' }}>
                <tr>
                  {CASE_DETAIL_HEADER.map((tableHeader, index) => (
                    <TableHeader 
                      key={index} tableHeader={{...tableHeader,width:`${tableHeader.width}px`}} sortConfig={queryParams}
                      changeIdOrder={changeIdOrder} classNames="text-center"
                    />
                  ))}
                </tr>
              </thead>

              <tbody className="table-group-divider">
                {caseListing.length > 0 &&
                  caseListing.map((item, index) => (
                    <tr key={index} className="align-middle">
                      <td className="text-center">
                        {item.indication.toLowerCase() === "other" ? (
                          <p className="text-danger mb-0">{item.case_id}</p>
                        ) : (
                          <button className="btn btn-blue btn-case rounded-0 px-1" onClick={() => openModal(item)}>
                            {item?.case_id}
                          </button>
                        )}
                      </td>
                      <td className="text-center">
                        <Link
                          to={{
                            pathname: baseUrl+`/${searchParams.id}`,
                            search: objectToQueryString(baseUrl === `/territories` ?
                              {
                                role: type === "doctor" ? "doctor" : searchParams?.role ?? '',
                                search_str: item.patient_id,
                                type: type,
                                id: searchParams.id,
                                start_date:searchParams?.start_date || "",
                            end_date:searchParams?.end_date || "",
                              } : {
                                id: searchParams.id,
                                filter_type: searchParams.filter_type,
                                role: type === "doctor" ? "doctor" : searchParams?.role ?? '',
                                period: searchParams.period,
                                global_patient_external_id: item.patient_id,
                                search_str: item.patient_id,
                                type: searchParams.type,
                                start_date:searchParams?.start_date || "",
                                end_date:searchParams?.end_date || "",
                              }
                            )
                          }}
                          state={baseUrl === `/territories` ? {
                            role: type === "doctor" ? "doctor" : searchParams?.role ?? '',
                            search_str: item.patient_id,
                            type: type,
                            id: searchParams.id
                          } : {
                            id: searchParams.id,
                            filter_type: searchParams.filter_type,
                            role: type === "doctor" ? "doctor" : searchParams?.role ?? '',
                            period: searchParams.period,
                            global_patient_external_id: item.patient_id,
                            search_str: item.patient_id,
                            type: searchParams.type,
                          }}
                          reloadDocument={true}
                          className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                        >
                          {item?.patient_id}
                        </Link>
                      </td>
                      <td className={`text-center`} >
                        <span className={item.bi_ct.toString().includes("-") ? "btn btn-success btn-sm px-1 text-nowrap" : ""}>
                          {item?.bi_ct}
                        </span>
                      </td>
                      <td className="text-center">{item?.qty}</td>
                      <td className='text-center'>{item.received}</td>
                      <td className="text-center">{item?.completed}</td>
                      <td className="text-center">{item?.treatment}</td>
                      <td className="text-center payer-td">{item?.payer}</td>
                      <td className="text-center">{item?.treatment ? "Treated" : item?.outcome}</td>
                      <td className='text-center'>{item.rx_cvge}</td>
                      <td className="text-center">{item?.med_cvge}</td>
                      <td className="text-center rxpa-td">{item?.rx_pa.data}</td>
                      <td className="text-center rxpa-td">{item?.med_pa.data}</td>
                      <td className={`text-center align-middle text-white background-color-${item && item.color_idx ? item.color_idx : 1}`}>
                        {item.case_status}
                      </td>
                      <td className={`text-center text-light align-middle fs-6`} id="next-steps">
                        {item.indication.toLowerCase() !== "other" ?
                          <>
                            {item && item['update'] && item['update'].length > 0 ? item['update'].map((step, index) => {
                              switch (step) {
                                case "Not Treated":
                                  return (
                                    <button key={index} className="btn btn-danger btn-sm rounded-0 m-1"
                                      onClick={() => setDataForCancelModal({ isModalVisible: true, caseId: item.case_id, prescriptionId: item.prescription_id })}

                                      type="button">
                                      <i className="fa fa-times"></i> Not Treated
                                    </button>
                                  );
                                case "Transferred":
                                  return (
                                    <button key={index} className="btn btn-success btn-sm rounded-0 m-1"
                                      onClick={() => ConfirmAlert('"Are you sure you want to mark this prescription transferred? This cannot be undone!', "xFerToSP", item.case_id)}
                                      type="button">
                                      <i className="fas fa-prescription"></i> Transferred
                                    </button>
                                  );
                                case "Treatment Date":
                                  return (
                                    <button key={index} className="btn btn-success btn-sm rounded-0 m-1"
                                      onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: item.case_id, prescriptionId: item.prescription_id, bentype: "med" })}
                                      type="button">

                                      <i className="fa fa-times"></i> Treatment Date
                                    </button>
                                  );
                                default:
                                  return (
                                    <p className="text-dark"> No Action Available</p>
                                  );
                              }
                            }) : <p className="text-dark"> No Action Available</p>}
                          </>
                          : <p className="text-dark"> No Action Available</p>}
                      </td>
                      <td className="text-center provider-td">
                        <Link
                          to={{
                            pathname: `/doctor_stats/${item.provider.doctor_id}`,
                            search: objectToQueryString({
                              id: item.provider.doctor_id,
                              type: "doctor",
                              role: "doctor",
                            })
                          }}
                          state={baseUrl === `/territories` ? {
                            role: type === "doctor" ? "doctor" : "manufacturer",
                            search_str: item.patient_id,
                            type: type,
                            id: searchParams.id
                          } : {
                            id: searchParams.id,
                            filter_type: searchParams.filter_type,
                            role: type === "doctor" ? "doctor" : "manufacturer",
                            period: searchParams.period,
                            global_patient_external_id: item.patient_id,
                            search_str: item.patient_id,
                            type: searchParams.type,
                          }}
                          reloadDocument
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                          title={item && item.provider ?
                            `${`Practice: ${item?.provider?.practice_name ?? ""}`}\n\n${`Address: ${item?.provider?.address ?? ""}`}\n\n${`Phone: ${item?.provider?.phone ?? ""}`}\n\n${`Fax: ${item?.provider?.fax ?? ""}`}`
                            : ""}
                        >
                          {item?.provider.doc_name}
                        </Link>
                        {item && isMobileOrTablet() &&
                          <PracticeContactInfo
                            children={<i className="bi bi-exclamation-circle-fill ms-1"></i>}
                            name={item?.provider?.practice_name ?? ""} 
                            address={item?.provider?.address ?? ""}
                            phone={item?.provider?.phone ?? ""}
                            fax={item?.provider?.fax ?? ""}
                            indexKey={index}
                          />
                        }
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>

          </div>
        </div>
      </div>

        {showingModal ? (
            <StepperModal
                onClick={() => {
                    setModal(false);
                    setCaseDetails(null);
                }}
                caseId={caseDetails.case_id}
            />
        ) : null}

      <ConfirmIndication
        isModalVisible={showCancelIndicationModal.isModalVisible}
        caseId={showCancelIndicationModal.caseId}
        prescriptionId={showCancelIndicationModal.prescriptionId}
        hideModal={() => {
          setDataForCancelIndication({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />
      <RequestDateOfTreatment
        isModalVisible={showRequestTreatmentModal.isModalVisible}
        caseId={showRequestTreatmentModal.caseId}
        prescriptionId={showRequestTreatmentModal.prescriptionId}
        bentype={showRequestTreatmentModal.bentype}
        hideModal={() => {
          setDataForRequestModalTreatment({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0,
            bentype: ""
          });
        }}
        refreshListing={() => redirectDecision()}
      />

      <CancelTreatment
        isModalVisible={cancelTreatmentModal.isModalVisible}
        caseId={cancelTreatmentModal.caseId}
        prescriptionId={cancelTreatmentModal.prescriptionId}
        hideModal={() => {
          setDataForCancelModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />
    </>
  );
};

export default CaseDetail;
